import React from 'react';
import { AnimatePresence } from 'framer-motion';
import { GatsbyBrowser } from 'gatsby';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => (
  <AnimatePresence exitBeforeEnter>{element}</AnimatePresence>
);
